module.exports = __webpack_public_path__ + "img/recharge-amount-empty-icon.c4f34969.png";